import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiError } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null=loading, false=anon, object=auth
    const [error, setError] = useState("");

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch (e) {
            setUser(false);
        }
    }, []);

    useEffect(() => { refresh(); }, [refresh]);

    const login = async (email, password) => {
        setError("");
        try {
            const { data } = await api.post("/auth/login", { email, password });
            setUser(data.user);
            return true;
        } catch (e) {
            setError(formatApiError(e));
            return false;
        }
    };

    const logout = async () => {
        try { await api.post("/auth/logout"); } catch (_) {}
        setUser(false);
    };

    const hasPermission = (perm) => {
        if (!user) return false;
        if (user.role === "admin") return true;
        return (user.permissions || []).includes(perm);
    };

    return (
        <AuthContext.Provider value={{ user, error, login, logout, refresh, hasPermission }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
